// extracted by mini-css-extract-plugin
export default {"container":"video_container__moeJ5","iconBox":"video_iconBox__J3AGN"};